"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PLUGINS = exports.buttonLabelFallback = void 0;
const browser_plugin_button_click_tracking_1 = require("@snowplow/browser-plugin-button-click-tracking");
const browser_plugin_client_hints_1 = require("@snowplow/browser-plugin-client-hints");
const browser_plugin_element_tracking_1 = require("@snowplow/browser-plugin-element-tracking");
const browser_plugin_enhanced_consent_1 = require("@snowplow/browser-plugin-enhanced-consent");
const patched_browser_plugin_link_click_tracking_1 = require("@angi/patched-browser-plugin-link-click-tracking");
const browser_plugin_ga_cookies_1 = require("@snowplow/browser-plugin-ga-cookies");
const browser_plugin_site_tracking_1 = require("@snowplow/browser-plugin-site-tracking");
const browser_plugin_web_vitals_1 = require("@snowplow/browser-plugin-web-vitals");
const browser_plugin_media_1 = require("@snowplow/browser-plugin-media");
const browser_plugin_performance_navigation_timing_1 = require("@snowplow/browser-plugin-performance-navigation-timing");
const customEnableConfigurations_1 = require("./customEnableConfigurations");
const componentAttributes_1 = __importDefault(require("../dataStructures/entities/componentAttributes"));
/**
 * Resolves a label for buttons the plugin cannot name from their own content.
 *
 * The Snowplow plugin resolves `data-sp-button-label` then `innerText`, which leaves
 * icon-only buttons unlabelled. Falling back to `aria-label` keeps those clicks
 * identifiable, and must be passed anywhere `enableButtonClickTracking` is configured.
 */
const buttonLabelFallback = (element) => { var _a; return (_a = element.getAttribute('aria-label')) !== null && _a !== void 0 ? _a : ''; };
exports.buttonLabelFallback = buttonLabelFallback;
const BUTTON_CLICK_CONFIGURATION = {
    defaultLabel: exports.buttonLabelFallback,
};
/**
 * Map of the Default Plugins for the Snowplow Web Tracker
 * These will be included in the tracker unless disabled by the user
 */
exports.DEFAULT_PLUGINS = {
    activityTracking: {
        enabled: true,
        enablePlugin: customEnableConfigurations_1.enableActivityTrackingWithConfig,
    },
    buttonClickTracking: {
        enabled: true,
        plugin: browser_plugin_button_click_tracking_1.ButtonClickTrackingPlugin,
        enablePlugin: browser_plugin_button_click_tracking_1.enableButtonClickTracking,
        enableConfiguration: BUTTON_CLICK_CONFIGURATION,
    },
    clientHints: {
        enabled: true,
        plugin: browser_plugin_client_hints_1.ClientHintsPlugin,
    },
    elementTracking: {
        enabled: true,
        plugin: browser_plugin_element_tracking_1.SnowplowElementTrackingPlugin,
        enablePlugin: browser_plugin_element_tracking_1.startElementTracking,
        enableConfiguration: {
            elements: [
                {
                    // Fire once per section as it scrolls into view, capturing section identity for analysts
                    selector: 'section',
                    name: 'page_section',
                    expose: {
                        when: 'element',
                        minPercentage: 0.25, // 25 % of section must be visible
                    },
                    details: [
                        { attributes: ['id'] },
                        { dataset: ['section', 'name', 'track'] },
                        { child_text: { heading: 'h1,h2,h3' } },
                        () => ({ total_page_depth: document.documentElement.scrollHeight }),
                    ],
                    context: (element) => {
                        // Find the component root anywhere within the section — never walk up
                        const root = element.querySelector('[data-snowplow-component-type]');
                        if (root === null)
                            return [];
                        const get = (attr) => root.getAttribute(attr);
                        const componentType = get('data-snowplow-component-type');
                        if (componentType === null)
                            return [];
                        const componentData = {
                            component_type: componentType,
                        };
                        const subtype = get('data-snowplow-component-subtype');
                        if (subtype !== null)
                            componentData.component_subtype = subtype;
                        const key = get('data-snowplow-component-key');
                        if (key !== null)
                            componentData.element_key = key;
                        const text = get('data-snowplow-component-text');
                        if (text !== null)
                            componentData.label = text;
                        const id = root.id;
                        if (id !== '')
                            componentData.element_id = id;
                        return [(0, componentAttributes_1.default)(componentData)];
                    },
                },
            ],
        },
    },
    enhancedConsent: {
        enabled: true,
        plugin: browser_plugin_enhanced_consent_1.EnhancedConsentPlugin,
    },
    gaCookies: {
        enabled: true,
        plugin: browser_plugin_ga_cookies_1.GaCookiesPlugin,
    },
    linkClickTracking: {
        enabled: true,
        plugin: patched_browser_plugin_link_click_tracking_1.LinkClickTrackingPlugin,
        enablePlugin: patched_browser_plugin_link_click_tracking_1.enableLinkClickTracking,
        enableConfiguration: {
            pseudoClicks: true,
            trackContent: true,
        },
    },
    siteTracking: {
        enabled: true,
        plugin: browser_plugin_site_tracking_1.SiteTrackingPlugin,
    },
    webVitals: {
        enabled: true,
        plugin: browser_plugin_web_vitals_1.WebVitalsPlugin,
    },
    mediaTracking: {
        enabled: true,
        plugin: browser_plugin_media_1.SnowplowMediaPlugin,
    },
    performanceNavigationTiming: {
        enabled: true,
        plugin: browser_plugin_performance_navigation_timing_1.PerformanceNavigationTimingPlugin,
    },
};
//# sourceMappingURL=data:application/json;base64,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


// WEBPACK FOOTER //
// ../../../src/plugins/constants.ts